module.exports = __webpack_public_path__ + "static/media/our_feishu.f800134d.png";